import { render, staticRenderFns } from "./index.vue?vue&type=template&id=158d31b7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/green-certificate-generating/_generate.scss?vue&type=style&index=0&id=158d31b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d31b7",
  null
  
)

export default component.exports